import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ProductGiftbox = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M20 6.25H17.2299C17.5555 5.7438 17.75 5.1453 17.75 4.5C17.75 2.708 16.292 1.25 14.5 1.25C13.4895 1.25 12.5966 1.7233 12 2.449C11.4034 1.7234 10.5105 1.25 9.5 1.25C7.708 1.25 6.25 2.708 6.25 4.5C6.25 5.1453 6.4445 5.7438 6.7701 6.25H4C3.0352 6.25 2.25 7.0352 2.25 8V21C2.25 21.9648 3.0352 22.75 4 22.75H20C20.9648 22.75 21.75 21.9648 21.75 21V8C21.75 7.0352 20.9648 6.25 20 6.25ZM20.25 8V14H12.5V7.75H20C20.1377 7.75 20.25 7.8623 20.25 8ZM14.5 2.75C15.4648 2.75 16.25 3.5352 16.25 4.5C16.25 5.4648 15.4648 6.25 14.5 6.25H12.75V4.5C12.75 3.5352 13.5352 2.75 14.5 2.75ZM7.75 4.5C7.75 3.5352 8.5352 2.75 9.5 2.75C10.4648 2.75 11.25 3.5352 11.25 4.5V6.25H9.5C8.5352 6.25 7.75 5.4648 7.75 4.5ZM4 7.75H11.5V14H3.75V8C3.75 7.8623 3.8623 7.75 4 7.75ZM3.75 21V15H11.5V21.25H4C3.8623 21.25 3.75 21.1377 3.75 21ZM20 21.25H12.5V15H20.25V21C20.25 21.1377 20.1377 21.25 20 21.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ProductGiftbox.displayName = 'ProductGiftbox';
